import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setChecking(false); return; }
    api.get("/auth/me").then((r) => {
      if (r.data?.is_admin) navigate("/admin/dashboard");
      else { setError("This Google account isn't authorized for admin access."); setChecking(false); }
    }).catch(() => setChecking(false));
    const params = new URLSearchParams(location.search);
    if (params.get("error") === "unauthorized") setError("This Google account isn't authorized for admin access.");
    else if (params.get("error") === "auth") setError("Sign-in failed. Please try again.");
  }, [navigate, location.search]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-black bp-grid flex items-center justify-center p-5">
      <div className="card-frame w-full max-w-md p-10 relative">
        <Lock className="text-[#C19B6C]" size={28} strokeWidth={1.4} />
        <h1 className="font-display text-3xl mt-6">Admin Access</h1>
        <p className="text-sm text-neutral-400 mt-3">Sign in with your authorized Google account.</p>
        {error && <div className="mt-5 text-sm text-red-400">{error}</div>}
        <button onClick={login} disabled={checking} className="btn-gold w-full mt-8 py-3.5 font-semibold" data-testid="admin-google-signin">
          {checking ? "Checking session…" : "Continue with Google"}
        </button>
        <p className="text-xs text-neutral-600 mt-8">
          Protected. Only allowlisted accounts can access the dashboard.
        </p>
      </div>
    </div>
  );
}
